import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'
import { Text } from '@pancakeswap/uikit'

export const LiquidityAprTooltip = ({ hasFarmApr }: { hasFarmApr: boolean }) => {
  const { t } = useTranslation()
  const farmAprTips = hasFarmApr ? (
    <>
      <Text bold>{t('This position must be staking in farm to apply the combined APR with farming rewards.')}</Text>
      <br />
    </>
  ) : null
  return (
    <TooltipBase>
      <>
        {farmAprTips}
        {t(
          'Calculated at the current rates with historical trading volume data, and subject to change based on various external variables.',
        )}
        <br />
        <br />
        {t('This figure is provided for your convenience only, and by no means represents guaranteed returns.')}
      </>
    </TooltipBase>
  )
}
